export default __webpack_public_path__ + "static/bicicletario-fab9970bf6cbab9c15ab68ea91464f13.jpg";